import { ContentItem, Region } from './@types/api';

export const siteName = 'Mfs';
export const blobUrl = 'https://mfsresources.blob.core.windows.net';
export const drawerWidth = 150;

export const dbDayFormat = 'YYYY-MM-DD';
export const dbTimeFormat = 'YYYY-MM-DDTHH:mm:ss';
export const fullDayFormat = 'dddd, MMMM D, YYYY';
export const colDateFormat = 'DD/MM/YYYY';
export const colDateFormat2 = 'DD/MM/YY';
export const uploadType = {
  image: 1,
  document: 2,
  audio: 3,
  video: 4,
  poster: 5,
  youtube: 6,
  liveReelVideo: 99,
  liveLoungeVideo: 100,
  blog: 101,
};

export const contentConfig: ContentItem[] = [
  {
    id: 0,
    name: 'index',
    displayName: 'Home',
    content: [
      {
        name: 'pageImage',
        displayName:
          'Default Header Image (only displayed when no video exists or when not set on other pages)',
        adminOnly: false,
        type: 'image',
        value: '',
      },
      {
        name: 'mainContent',
        displayName: 'Welcome Text',
        adminOnly: false,
        type: 'richtext',
        value: '',
      },
      {
        name: 'contactUs',
        displayName: 'Contact Us Text',
        adminOnly: false,
        type: 'textarea',
        value: '',
      },
    ],
  },
  {
    id: 0,
    name: 'songs',
    displayName: 'Songs',
    content: [
      {
        name: 'pageImage',
        displayName: 'Header Image',
        adminOnly: false,
        type: 'image',
        value: '',
      },
      {
        name: 'mainContent',
        displayName: 'Songs Text',
        adminOnly: false,
        type: 'richtext',
        value: '',
      },
      {
        name: 'contactUs',
        displayName: 'Contact Us Text',
        adminOnly: false,
        type: 'textarea',
        value: '',
      },
    ],
  },
  {
    id: 0,
    name: 'video',
    displayName: 'Videos',
    content: [
      {
        name: 'pageImage',
        displayName: 'Header Image',
        adminOnly: false,
        type: 'image',
        value: '',
      },
      {
        name: 'mainContent',
        displayName: 'Videos Text',
        adminOnly: false,
        type: 'richtext',
        value: '',
      },
      {
        name: 'contactUs',
        displayName: 'Contact Us Text',
        adminOnly: false,
        type: 'textarea',
        value: '',
      },
    ],
  },
  {
    id: 0,
    name: 'testimonials',
    displayName: 'Testimonials',
    content: [
      {
        name: 'pageImage',
        displayName: 'Header Image',
        adminOnly: false,
        type: 'image',
        value: '',
      },
      {
        name: 'mainContent',
        displayName: 'Testimonials Text',
        adminOnly: false,
        type: 'richtext',
        value: '',
      },
      {
        name: 'contactUs',
        displayName: 'Contact Us Text',
        adminOnly: false,
        type: 'textarea',
        value: '',
      },
    ],
  },
  {
    id: 0,
    name: 'faq',
    displayName: 'FAQs',
    content: [
      {
        name: 'pageImage',
        displayName: 'Header Image',
        adminOnly: false,
        type: 'image',
        value: null,
      },
      {
        name: 'mainContent',
        displayName: 'FAQs Text',
        adminOnly: false,
        type: 'richtext',
        value: '',
      },
      {
        name: 'contactUs',
        displayName: 'Contact Us Text',
        adminOnly: false,
        type: 'textarea',
        value: '',
      },
    ],
  },
  {
    id: 0,
    name: 'social',
    displayName: 'Social',
    content: [
      {
        name: 'pageImage',
        displayName: 'Header Image',
        adminOnly: false,
        type: 'image',
        value: null,
      },
      {
        name: 'mainContent',
        displayName: 'Social Text',
        adminOnly: false,
        type: 'richtext',
        value: '',
      },
      {
        name: 'contactUs',
        displayName: 'Contact Us Text',
        adminOnly: false,
        type: 'textarea',
        value: '',
      },
    ],
  },
];

export const pricetypesRequiringHotel = [
  'aberdeen',
  'aberdeenNorth',
  'dumfries',
  'highlandsIslands',
  'inverness',
];

export const regionTypes: Region[] = [
  { id: 'aberdeen', name: 'Aberdeen City' },
  { id: 'aberdeenNorth', name: 'Aberdeen North' },
  { id: 'ayrshire', name: 'Ayrshire' },
  { id: 'borders', name: 'Scottish Borders' },
  { id: 'dundee', name: 'Dundee' },
  { id: 'dumfries', name: 'Dumfries & Galloway' },
  { id: 'edinburgh', name: 'Edinburgh & Lothians' },
  { id: 'fife', name: 'Fife - Central & South' },
  { id: 'stAndrews', name: 'Fife - St Andrews & East' },
  { id: 'glasgow', name: 'Glasgow & Strathclyde' },
  { id: 'highlandsIslands', name: 'Highlands & Islands' },
  { id: 'inverness', name: 'Inverness' },
  { id: 'lochLomondTrossachs', name: 'Loch Lomond & Trossachs' },
  { id: 'perthshire', name: 'Perthshire' },
  { id: 'westLothian', name: 'West Lothian' },
  { id: 'other', name: 'Other' },
  { id: 'priceA', name: '1 hr - Local' },
  { id: 'priceB', name: '2 hrs - Ayrshire' },
  { id: 'priceC', name: '3 hrs - Aberdeen' },
  { id: 'priceD', name: '4+ hrs - Inverness' },
];

export const bookingStatus = {
  NONE: 0,
  OPEN: 1,
  CANCELLED: 2,
  COMPLETE: 4,
  ONHOLD: 6,
  CONFIRMED: 9,
};

export const enquiryStatus = {
  NONE: 0,
  OPEN: 1,
  CANCELLED: 2,
  CONVERTED: 5,
  ONHOLD: 6,
  RESPONDED: 10,
};

export const clientStatus = {
  ACTIVE: 3,
  PARKED: 7,
  CLOSED: 8,
};

export const artistStatus = {
  LIVE: 11,
  ADMINONLY: 12,
  REMOVED: 13,
};

export const artistCategory = {
  WEDDINGBAND: 1,
  CEILIDHBANDS: 2,
  JAZZ: 3,
  SPECIALIST: 6,
  CLASSICAL: 8,
};

export const eventTypes = {
  WEDDING: 1,
  BIRTHDAY: 2,
  CORPORATE: 3,
  OTHER: 4,
  OTHERGIG: 5,
  FINNEGANS: 6,
  MFSPUBGIG: 7,
  PUBLICEVENT: 8,
  SHOWCASE: 9,
};

export const eventTypeDescription = {
  1: 'Wedding',
  2: 'Birthday',
  3: 'Corporate Event',
  4: 'Other Event',
  5: 'Other gig',
  6: 'Finnegans',
  7: 'Berlinkeys,Brewhemia',
  8: 'Public Event',
  9: 'MFS Showcase',
};
